export default __webpack_public_path__ + "static/media/ies_header_voces_ENG.f316348f.png";